module.exports = __webpack_public_path__ + "img/phone.1c60d44f.png";